import React, {useState, useEffect, useCallback} from 'react'

import { ValidationForm, TextInput, SelectGroup } from 'react-bootstrap4-form-validation';
import { Button } from 'reactstrap';
import { Modal, ModalDialog } from 'react-bootstrap';
import ShowMessages from '../../components/Exceptions'
import Loading from '../../components/Loading';
import Draggable from 'react-draggable';

import api from '../../services/api';
import setStatistic from '../../services/apiStatistic'
import  loadingButton  from '../layouts/Buttons'

class DraggableModalDialog extends React.Component {
	render() {
		return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
	}
}

export default function ModalMeasurement({showModal, handleCloseModal,editState, data, handleReload}) {
    const [loading, setLoading]      = useState(false)

    const [costcenterid,setCostCenterId] = useState('')
    const [costcenter,setCostCenter] = useState('')
    const [customerid,setCustomerid] = useState('')
    const [customer,setCustomer] = useState('')
    const [measurement_number,setMeasurement_Number] = useState('')
    const [start_date,setStart_Date] = useState('')
    const [end_date,setEnd_Date] = useState('')
    const [measured_value,setMeasured_Value] = useState('')
    const [invoiced_amount,setInvoiced_Amount] = useState('')
    const [type, setType] = useState('Realizado')

    const [customerData, setCustomerData] = useState([])
    const [costCenterData, setCostCenterData] = useState([])

    // Função para formatar valor monetário (sem R$)
    const formatCurrency = (value) => {
        if (!value) return ''
        // Remove tudo que não é número
        const numericValue = value.toString().replace(/\D/g, '')
        if (!numericValue) return ''
        // Converte para número e divide por 100 para ter centavos
        const numberValue = parseFloat(numericValue) / 100
        // Formata com separadores brasileiros (1.234,56)
        return numberValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }

    // Função para desformatar valor monetário (retorna apenas números)
    const unformatCurrency = (value) => {
        if (!value) return ''
        // Remove tudo que não é número
        const numericValue = value.toString().replace(/\D/g, '')
        if (!numericValue) return ''
        // Converte para número e divide por 100 para ter o valor real
        return (parseFloat(numericValue) / 100).toString()
    }

    // Função para formatar data sem problemas de timezone
    const formatDate = (dateValue) => {
        if (!dateValue) return ''
        // Se for string no formato ISO (YYYY-MM-DD), extrai os componentes diretamente
        if (typeof dateValue === 'string' && dateValue.match(/^\d{4}-\d{2}-\d{2}/)) {
            const [year, month, day] = dateValue.split('T')[0].split('-')
            return `${year}-${month}-${day}`
        }
        // Caso contrário, cria a data localmente
        const date = new Date(dateValue)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    const setData = useCallback((obj,clear) => {
        setCostCenterId(clear ? '' : obj.costcenterid)
        setCostCenter(clear ? '' : obj.costcenter)
        setCustomerid(clear ? '' : obj.customerid)
        setCustomer(clear ? '' : obj.customer)
        setMeasurement_Number(clear ? '' : obj.measurement_number)
        setStart_Date(clear ? '' : formatDate(obj.start_date))
        setEnd_Date(clear ? '' : formatDate(obj.end_date))
        // Formata valores monetários: se vier como número, converte para string e formata
        if (clear) {
            setMeasured_Value('')
            setInvoiced_Amount('')
        } else {
            if (obj.measured_value) {
                // Se for número, converte diretamente; se for string, tenta parsear
                const value = typeof obj.measured_value === 'number' 
                    ? obj.measured_value.toString() 
                    : obj.measured_value.toString().replace(/\./g, '').replace(',', '.')
                const numValue = parseFloat(value) || 0
                setMeasured_Value(numValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            } else {
                setMeasured_Value('')
            }
            
            if (obj.invoiced_amount) {
                const value = typeof obj.invoiced_amount === 'number' 
                    ? obj.invoiced_amount.toString() 
                    : obj.invoiced_amount.toString().replace(/\./g, '').replace(',', '.')
                const numValue = parseFloat(value) || 0
                setInvoiced_Amount(numValue.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            } else {
                setInvoiced_Amount('')
            }
        }
        
        setType(clear ? 'Realizado' : obj.type)
    }, [])

    const handleSubmit = async(event) => {
        event.preventDefault()
        loadingButton(true,document.querySelector('#submit-measurement'),document.querySelector('#submit-measurement').children[0].classList,document.querySelector('#submit-measurement').lastChild.nodeValue)
        try {
            let _data = {costcenterid,
                         costcenter,
                         customerid,
                         customer,
                         measurement_number,
                         start_date,
                         end_date,
                         measured_value: unformatCurrency(measured_value),
                         invoiced_amount: unformatCurrency(invoiced_amount),
                         type}

            if (editState)
                await api.put('/measurement/' + data.idmeasurement, _data)
                      .then(response => {
                         ShowMessages(response)
                         if (response.ok) {
                             if (response.data.status === 200) {
                                 handleCloseModal()
                                 handleReload(true)
                             } else
                                 loadingButton(false,document.querySelector('#submit-measurement'))
                         } else
                             loadingButton(false,document.querySelector('#submit-measurement'))
                     })
                     .catch( error => {
                         loadingButton(false,document.querySelector('#submit-measurement'))
                         ShowMessages(error)
                     })
            else
                await api.post('/measurement', _data)
                         .then(response => {
                         ShowMessages(response)
                         if (response.ok) {
                             if (response.data.status === 200) {
                                 handleCloseModal()
                                 handleReload(true)
                             } else
                                 loadingButton(false,document.querySelector('#submit-measurement'))
                          } else
                             loadingButton(false,document.querySelector('#submit-measurement'))
                       })
                       .catch( error => {
                         loadingButton(false,document.querySelector('#submit-measurement'))
                         ShowMessages(error)
                       })
        } catch (response) {
            loadingButton(false,document.querySelector('#submit-measurement'))
            ShowMessages(response)
        }
    }

    useEffect(() => {
        if (editState)
            setData(data,false)
        else
            setData({},true)
    },[data,editState,showModal,setData])

    useEffect(() => {
        const getData = async() => {
            setLoading(true)
            const [_customerData,_costCenterData] = await Promise.all([
                api.get('/getcustomer').then(res => res),
                api.get('/getcostcenterUser').then(res => res)
            ]);

            setCustomerData(_customerData.data)
            setCostCenterData(_costCenterData.data)
            setLoading(false)
        }
        getData()
        setStatistic('modals\\modal-measurement')
    } ,[])

    return (
      <Modal
        size="md"
        show={showModal}
        onHide={handleCloseModal}
        animation={true}
        backdrop="static"
        dialogAs={DraggableModalDialog}
      >
        <ValidationForm
          onSubmit={handleSubmit}
          className="modal-content"
          setFocusOnError={true}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ marginBottom: "0px" }}>
              <i className="fa fa-ruler-combined"></i> Propriedades de Medições
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Loading loading={loading} addClass="heigth330px"/>
            <div className={`${loading ? "hidden" : ""}`}>
              <div>
                <label>Cliente</label>
                <div className="input-group">
                  <SelectGroup
                    name="customerid"
                    id="customerid"
                    value={customerid}
                    onChange={(e) => {
                      setCustomerid(e.target.value);
                      setCustomer(
                        e.target.options[e.target.selectedIndex].text
                      );
                    }}
                    errorMessage={{ required: "Por favor, informe o cliente!" }}
                    className="form-select"
                  >
                    <option value="">Selecione</option>
                    {customerData.map((item) => {
                      return (
                        <option value={item.id}>{item.name}</option>
                      );
                    })}
                  </SelectGroup>
                </div>
              </div>
              <div>
                <label>Obra</label>
                <div className="input-group">
                  <SelectGroup
                    name="costcenterid"
                    id="costcenterid"
                    value={costcenterid}
                    onChange={(e) => {
                      setCostCenterId(e.target.value);
                      setCostCenter(
                        e.target.options[e.target.selectedIndex].text
                      );
                    }}
                    errorMessage={{ required: "Por favor, informe uma obra!" }}
                    className="form-select"
                  >
                    <option value="">Selecione</option>
                    {costCenterData && costCenterData.map((item) => {
                      return (
                        <option value={item.id}>{item.name}</option>
                      );
                    })}
                  </SelectGroup>
                </div>
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <div style={{ width: "100%" }}>
                  <label>Nº Medição</label>
                  <div className="input-group">
                    <TextInput
                      name="measurement_number"
                      id="measurement_number"
                      type="text"
                      required
                      maxLength={100}
                      errorMessage={{
                        required: "Por favor, informe um nº de medição!",
                      }}
                      value={measurement_number}
                      className="form-control "
                      onChange={(e) => setMeasurement_Number(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <label>Período Inicial</label>
                  <div className="input-group">
                    <TextInput
                      name="start_date"
                      id="start_date"
                      type="date"
                      required
                      maxLength={100}
                      errorMessage={{
                        required: "Por favor, informe uma data inicial!",
                      }}
                      value={start_date}
                      className="form-control "
                      onChange={(e) => setStart_Date(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <label>Período Final</label>
                  <div className="input-group">
                    <TextInput
                      name="end_date"
                      id="end_date"
                      type="date"
                      required
                      maxLength={100}
                      errorMessage={{
                        required: "Por favor, informe uma data final!",
                      }}
                      value={end_date}
                      className="form-control "
                      onChange={(e) => setEnd_Date(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <div style={{ width: "100%" }}>
                  <label>Valor Medido</label>
                  <div className="input-group">
                    <TextInput
                      name="measured_value"
                      id="measured_value"
                      type="text"
                      required
                      maxLength={100}
                      errorMessage={{
                        required: "Por favor, informe um valor!",
                      }}
                      value={measured_value}
                      className="form-control text-right"
                      style={{ textAlign: 'right' }}
                      onChange={(e) => {
                        const formatted = formatCurrency(e.target.value)
                        setMeasured_Value(formatted)
                      }}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <label>Valor Faturado</label>
                  <div className="input-group">
                    <TextInput
                      name="invoiced_amount"
                      id="invoiced_amount"
                      type="text"
                      required
                      maxLength={100}
                      errorMessage={{
                        required: "Por favor, informe um valor!",
                      }}
                      value={invoiced_amount}
                      className="form-control text-right"
                      style={{ textAlign: 'right' }}
                      onChange={(e) => {
                        const formatted = formatCurrency(e.target.value)
                        setInvoiced_Amount(formatted)
                      }}
                      autoComplete="off"
                    />
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <label>Tipo</label>
                  <div className="input-group">
                    <SelectGroup
                      name="type"
                      id="type"
                      value={type}
                      onChange={(e) => {
                        setType(e.target.value);
                      }}
                      className="form-select"
                    >
                      <option value="Realizado">Realizado</option>
                      <option value="Previsto">Previsto</option>
                    </SelectGroup>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              id="submit-measurement"
              className={`btn-theme ${loading ? "hidden" : ""}`}
            >
              <em className="fa fa-save"></em> Salvar
            </Button>
            <Button className="btn-ligth-gray" onClick={handleCloseModal}>
              <em className="fa fa-door-closed"></em> Fechar
            </Button>
          </Modal.Footer>
        </ValidationForm>
      </Modal>
    );
}